import { useLingui } from "@lingui/react/macro";
import { Button } from "@orbin/ui-web";
import { formatBrl } from "../lib/metering";

/** The top-up sizes in BRL, one of which is chosen. */
export function PaymentAmountPicker({
  amounts,
  value,
  onChange,
}: {
  amounts: readonly number[];
  value: number;
  onChange: (cents: number) => void;
}) {
  const { t, i18n } = useLingui();
  return (
    <div role="radiogroup" aria-label={t`Amount`} className="grid grid-cols-2 gap-2">
      {amounts.map((cents) => (
        <Button
          key={cents}
          type="button"
          role="radio"
          aria-checked={value === cents}
          variant={value === cents ? "default" : "outline"}
          onClick={() => onChange(cents)}
        >
          {formatBrl(cents, i18n.locale || "en")}
        </Button>
      ))}
    </div>
  );
}
